import React, { useEffect, useState } from "react";
import "./TheTeacherDashboard.css";
import { HiOutlineDocumentText } from "react-icons/hi2";

export default function ExamStatusStatistics({ dashboard_data, initial_loading, employeeType }) {
  const [activeTab, setActiveTab] = useState("Review");

  const [examData, setExamData] = useState({
    Review: [],
    "In-Review": [],
    "Refer-Back": [],
    "Review Completed": [],
    "Ready to publish": [],
    Published: [],
  });

  const tabs = Object.keys(examData);

  useEffect(() => {
    if (
      dashboard_data?.success &&
      dashboard_data.data?.status_wise_assigned_latest_assessments
    ) {
      const assessments = dashboard_data.data.status_wise_assigned_latest_assessments;

      const statusMap = {
        Initial: "Initial",
        Ready: "Ready",
        ProofReading: "ProofReading",
        Review: "Review",
        InReview: "In-Review",
        ReferBack: "Refer-Back",
        ReviewCompleted: "Review Completed",
        ReadyToPublish: "Ready to publish",
        Published: "Published",
      };

      const adminAllowed = [
        "Initial",
        "Ready",
        "ProofReading",
        "Review",
        "In-Review",
        "Refer-Back",
        "Review Completed",
        "Ready to publish",
        "Published"
      ];
      const teachAllowed = [
        "Review",
        "In-Review",
        "Refer-Back",
        "Review Completed",
        "Ready to publish",
        "Published",
      ];

      const allowedStatuses =
        (employeeType === "MASAD" || employeeType === "DEOP")
          ? adminAllowed
          : teachAllowed;

      const updatedExamData = allowedStatuses.reduce((acc, status) => {
        acc[status] = [];
        return acc;
      }, {});

      for (const [statusKey, exams] of Object.entries(assessments)) {
        const mappedKey = statusMap[statusKey];
        if (allowedStatuses.includes(mappedKey)) {
          updatedExamData[mappedKey] = exams.map(
            (exam) => `${exam.title} (ID: ${exam.asmnt_id || exam.assessment_id})`
          );
        }
      }

      setExamData(updatedExamData);
    }
  }, [dashboard_data, employeeType]);

  return (
    <div className="exam-status-wrapper card">
      <div className="paper-count-header">
        <div className="paper-count-title">
          <span className="paper-count-icon" aria-hidden="true">
            <HiOutlineDocumentText />
          </span>
          <h6 className="exam-status-title">
            {employeeType === "TEACH" ? "My Paper Details Status Statistics" : "Paper Details Status Statistics"}
          </h6>
        </div>
        <span className="dots-icon">⋯</span>
      </div>

      <div className="paper-tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`paper-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
            type="button"
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="exam-list">
        {examData[activeTab].length > 0 ? (
          examData[activeTab].slice(0, 5).map((exam, index) => (
            <div key={index} className="exam-row d-flex align-items-center">
              <span className="exam-icon" aria-hidden="true">
                <HiOutlineDocumentText />
              </span>
              <span className="exam-text">{exam}</span>
            </div>
          ))
        ) : (
          <p className="no-data text-muted">No data available for {activeTab}</p>
        )}
      </div>
    </div>
  );
}
